import axios from '@/lib/v2/axios';

export interface StoredPaymentMethod {
  id: string;
  type: 'card' | 'us_bank_account';
  last4: string;
  created: number;
  is_default?: boolean;
  brand?: string;
  exp_month?: number;
  exp_year?: number;
  bank_name?: string;
  account_type?: string;
}

export async function getSetupIntent(communityId: string | number): Promise<{ client_secret: string; stripe_account_id: string }> {
  const response = await axios.post('/api/v2/payment-methods/setup-intent', { community_id: String(communityId) });
  return response.data;
}

export async function getPaymentMethods(communityId: string | number): Promise<{ payment_methods: StoredPaymentMethod[] }> {
  const response = await axios.get('/api/v2/payment-methods', { params: { community_id: String(communityId) } });
  return response.data;
}

export async function deletePaymentMethod(paymentMethodId: string, communityId: string | number): Promise<void> {
  await axios.delete(`/api/v2/payment-methods/${paymentMethodId}`, { params: { community_id: String(communityId) } });
}

export async function setDefaultPaymentMethod(paymentMethodId: string, communityId: string | number): Promise<void> {
  await axios.post(`/api/v2/payment-methods/${paymentMethodId}/default`, { community_id: String(communityId) });
}
